import React from "react";
import { Link } from "react-router-dom";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import HighchartsExporting from "highcharts/modules/exporting";
import jwt_decode from "jwt-decode";
import { useCookies } from "react-cookie";
import { useSelector } from "react-redux";
import { getWithExpiry } from "../../../common";
import { useTranslation } from "react-i18next";

const GrayToGoldLinear = (props) => {
  let answersData = {};
  const [cookies] = useCookies(["sustainyou_user_jwt"]);
  const userG2gData = useSelector(
    (state) => state?.userdata?.allUserData?.g2g_data
  );

  const [translation] = useTranslation("translations");

  let updatedData = {};

  if (cookies.sustainyou_user_jwt) {
    const jwtDecoded = jwt_decode(cookies.sustainyou_user_jwt);
    const savedData = getWithExpiry(`temp_g2g_user${jwtDecoded.id}`);

    if (savedData) {
      updatedData = savedData;
    }
  }

  if (updatedData && Object.keys(updatedData).length > 0) {
    answersData = updatedData;
  } else {
    answersData = userG2gData;
  }

  let jobbetPoints = [];
  // let myselfPoints = [];
  // let hemmaPoints = [];

  let answerDates = answersData?.jobbet?.answers?.map((answer) => {
    let totalAnswered = answer.total_answered;
    let totalPoints = answer.total_points;

    if (!totalAnswered) {
      jobbetPoints.push(0);
    } else {
      jobbetPoints.push(Math.round((totalPoints / totalAnswered) * 10) / 10);
    }

    return answer.date;
  });

  let myselfPoints = answersData?.myself?.answers?.map((answer) => {
    let totalAnswered = answer.total_answered;
    let totalPoints = answer.total_points;

    let points = 0;

    if (!totalAnswered) {
      points = 0;
    } else {
      points = Math.round((totalPoints / totalAnswered) * 10) / 10;
    }

    return points;
  });

  let hemmaPoints = answersData?.hemma?.answers?.map((answer) => {
    let totalAnswered = answer.total_answered;
    let totalPoints = answer.total_points;

    let points = 0;

    if (!totalAnswered) {
      points = 0;
    } else {
      points = Math.round((totalPoints / totalAnswered) * 10) / 10;
    }

    return points;
  });

  const options = {
    chart: {
      type: "spline",
      scrollablePlotArea: {
        minWidth: 600,
        scrollPositionX: 1,
      },
    },
    title: {
      text: translation('nvi_title'),
      align: "center",
      y: 25,
      margin: 25,
    },
    subtitle: {
      text: "",
      align: "left",
    },
    xAxis: {
      tickInterval: 1,
      categories: answerDates,
    },
    yAxis: {
      type: "linear",
      min: 0,
      max: 4,
      plotBands: [
        {
          // Light air
          from: 0,
          to: 1,
          color: "rgba(89,88,88,0.8)",
          label: {
            text: "",
            style: {
              color: "#fff",
            },
          },
        },
        {
          // Light air
          from: 1,
          to: 2,
          color: "rgba(177, 93, 55, 0.8)",
          label: {
            text: "",
            style: {
              color: "#fff",
            },
          },
        },
        {
          // Light breeze
          from: 2,
          to: 3,
          color: "rgba(169, 169, 169, 0.8)",
          label: {
            text: "",
            style: {
              color: "#f1c232",
            },
          },
        },
        {
          // Gentle breeze
          from: 3,
          to: 4,
          color: "rgba(185, 147, 83, 0.8)",
          label: {
            text: "",
            style: {
              color: "#6aa750",
            },
          },
        },
      ],
    },
    plotOptions: {
      spline: {
        lineWidth: 3,
        states: {
          hover: {
            lineWidth: 4,
          },
        },
        marker: {
          enabled: true,
        },
        dataLabels: {
          enabled: true,
        },
      },
    },
    series: [
      {
        name: translation('the_job'),
        data: jobbetPoints,
        color: "#486975",
      },
      {
        name: translation('myself'),
        data: myselfPoints,
        color: "#3f3b33",
      },
      {
        name: translation('home'),
        data: hemmaPoints,
        color: "#99967a",
      },
    ],
    navigation: {
      menuItemStyle: {
        fontSize: "10px",
      },
    },
  };

  if (typeof Highcharts === "object") {
    HighchartsExporting(Highcharts);
  }

  return (
    <div className="hvi-chart-wrap">
      {props.loading && (
        <div className="d-flex align-items-center">
          <div className="spinner-border spinner-border-sm" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <h5 className="ps-2">{translation('processing_latest')}</h5>
        </div>
      )}

      {answerDates?.length > 0 && (
        <>
          <HighchartsReact highcharts={Highcharts} options={options} />

          
        </>
      )}

      {!answerDates?.length > 0 && (
        <div className="row">
          <div className="col-12">
            <div className="alert alert-downriver" role="alert">
              <div className="row align-items-center">
                <div className="col-12 col-lg-8">
                  <span>{translation('no_nvi_data')}</span>
                </div>
                <div className="col-12 col-lg-4 text-center">
                  <Link
                    to="/fran-gra-till-guld/"
                    className="btn btn-halite-blue rounded-pill px-4"
                  >
                    <span className="pe-2">{translation('go_to_test')}</span>
                    <i className="fa fa-angle-right" aria-hidden="true"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default GrayToGoldLinear;
